var map = {
	"./choose_picture.png": "v3yC",
	"./close_chat.png": "abAh",
	"./take_photos.png": "gTVu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ReAL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat/extra ^\.\/.*\.png$
// module id = ReAL
// module chunks = 1